"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
function ErrorPage() {
    const error = (0, react_router_dom_1.useRouteError)();
    console.error(error);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "error-page" }, { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Oops!" }), (0, jsx_runtime_1.jsx)("p", { children: "Sorry, an unexpected error has occurred." }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("i", { children: error.statusText || error.message }) })] })));
}
exports.default = ErrorPage;
